import React, { FunctionComponent } from 'react';
import { IconProps } from '.';

const XIcon: FunctionComponent<IconProps> = ({ size = 24, className = "" }) => (
  <svg className={className} width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M18 6L6 18' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M6 6L18 18' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export default XIcon;
